import { HttpClient, HttpParams } from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { api } from '../api';
import { ExternalResumeRequestDTO } from '../upload-resume/external-resume-request.dto';
import { ProfileService } from '../profile/profile.service';
import { ResumeService } from '../resume/resume.service';


@Injectable()
export class UploadResumeService {
  private resumeData: any = null;
  public linkedInParsedResume: any;
  constructor(private http: HttpClient,
    private profileService: ProfileService,
    private resumeService: ResumeService) { }

  saveResumeData(connector: string, accessCode: string, redirectURI: string, fileId: number, fileName: string) {
    return this.http.post(api.resume.SAVE_RESUME, this.getResumeRequest(connector, accessCode, redirectURI, fileId, fileName))
      .map(res => {
        if (res['errorCode'] === 0) {
          this.resumeService.resume = null;
          // Clearing the candidate's profile data cache as the resume data is updated.
          this.profileService.updateProfileData();
          return true;
        } else {
          return false;
        }
      })
      .catch(this.handleError);
  }

  private getResumeRequest(connector: string, code: string,
    redirectURI: string, fileId: number, fileName: string): ExternalResumeRequestDTO {
    const request: ExternalResumeRequestDTO = new ExternalResumeRequestDTO();
    request.Connector = connector;
    request.Code = code;
    request.RedirectURI = redirectURI;
    request.FileId = fileId;
    request.FileName = fileName;
    return request;
  }

  private handleError(error: any) {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  /*Get the file from the local drive/ 3rd party paths and create a copy of the same in the Data Store*/
  uploadResume(formData) {
    return this.http.post(api.resume.UPLOAD, formData).toPromise()
      .catch(this.handleError);
  }

  /*Parse the document saved into the Data Store*/
  parseResume(fileId) {
    const gzip = 'true';
    const httpParams: HttpParams = new HttpParams()
      .set('fileId', fileId)
      .set('GZipCompressed', gzip);
    // Clearing the candidate's profile data cache as the resume data is updated.
    this.profileService.updateProfileData();
    return this.http.get(api.resume.PARSE_FILE, { params: httpParams })
      .toPromise();
  }

  dropboxAuthToken(files) {
    return this.http.get(files.link)
      .toPromise();
  }

}



// WEBPACK FOOTER //
// ../UI/src/app/shared/upload-resume/upload-resume.service.ts